import React, { FC } from 'react';
import { styled } from '@mui/material';
import { ZIndexes } from 'enums/z-indexes';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

const PositionedModal = styled(Modal)({
  zIndex: ZIndexes.External_Modal_Second,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const PositionedBox = styled(Box)((theme) => ({
  [theme.theme.breakpoints.up('md')]: {
    width: '40%',
  },
}));

interface ModalConfirmProps {
  open: boolean;
  title: string;
  content: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => any;
  onCancel: () => any;
}

const ModalConfirm: FC<ModalConfirmProps> = ({
  open,
  title,
  content,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  return (
    <PositionedModal open={open} onClose={onCancel}>
      <PositionedBox className="modal-confirm" textAlign='center'>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {title}
        </Typography>

        <Typography
          id="modal-modal-description"
          margin={2}
          component="p"
        >
          {content}
        </Typography>

        <Divider sx={{ marginBottom: '0 !important' }} />

        <Grid className="modal-actions">
          <Button className="btn-confirm" variant="text" onClick={onConfirm}>
            {confirmText}
          </Button>
          <Divider />
          <Button className="btn-cancel" variant="text" onClick={onCancel}>
            {cancelText}
          </Button>
        </Grid>
      </PositionedBox>
    </PositionedModal>
  );
};

export default ModalConfirm;
